import { Link } from "react-router-dom";

interface CTASectionProps {
  title?: string;
  description?: string;
}

export default function CTASection({
  title = "Roll Press 제어 시스템과 MOOG 제품 관련 기술 문의를 남겨주세요.",
  description = "도면, 회로도, 기존 장비 정보가 있으시면 함께 보내주세요. 보다 정확하고 빠른 검토가 가능합니다.",
}: CTASectionProps) {
  return (
    <section className="relative py-16 md:py-20 bg-primary-800 text-background-50 overflow-hidden">
      <div className="absolute inset-0 bp-grid opacity-15" />
      <div className="absolute -top-24 -right-24 w-72 h-72 rounded-full bg-accent-500/20 blur-3xl" />
      <div className="absolute -bottom-24 -left-24 w-72 h-72 rounded-full bg-primary-400/20 blur-3xl" />

      <div className="relative max-w-6xl mx-auto px-4 md:px-8 text-center">
        <span className="inline-flex items-center gap-2 text-[11px] font-semibold tracking-[0.2em] uppercase text-accent-200 mb-4">
          <span className="w-6 h-px bg-accent-300" />
          Get In Touch
          <span className="w-6 h-px bg-accent-300" />
        </span>
        <h2 className="text-2xl md:text-4xl font-heading font-extrabold leading-tight max-w-3xl mx-auto">
          {title}
        </h2>
        <p className="mt-4 text-sm md:text-base text-background-200 max-w-2xl mx-auto leading-relaxed">
          {description}
        </p>

        <div className="mt-8 flex flex-col sm:flex-row items-stretch sm:items-center justify-center gap-3">
          <Link
            to="/contact?type=quote"
            className="inline-flex items-center justify-center gap-2 px-5 py-3 rounded-md bg-background-50 text-primary-800 font-semibold text-sm hover:bg-background-100 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-file-list-3-line w-4 h-4 flex items-center justify-center" />
            견적 문의
          </Link>
          <Link
            to="/contact?type=tech"
            className="inline-flex items-center justify-center gap-2 px-5 py-3 rounded-md bg-accent-500 hover:bg-accent-600 text-background-50 font-semibold text-sm cursor-pointer whitespace-nowrap"
          >
            <i className="ri-tools-line w-4 h-4 flex items-center justify-center" />
            기술 문의
          </Link>
          <Link
            to="/contact?type=product"
            className="inline-flex items-center justify-center gap-2 px-5 py-3 rounded-md border border-background-50/40 text-background-50 hover:bg-background-50/10 font-semibold text-sm cursor-pointer whitespace-nowrap"
          >
            <i className="ri-shopping-cart-2-line w-4 h-4 flex items-center justify-center" />
            제품 문의
          </Link>
        </div>
      </div>
    </section>
  );
}